import { FontFamily } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledStepTitle: SxProps = {
  fontFamily: FontFamily.heading,
};
